export const SET_SESSION = 'main/SET_SESSION';
export const RESET_SESSION = 'main/RESET_SESSION';

export const setSession = session => ({
  type: SET_SESSION,
  session,
});

export const resetSession = () => ({
  type: RESET_SESSION,
});



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/actions/session-actions.ts